import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IProductVaticCategoryData, IProductVaticCategoryResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
AxiosCurlirize(axios, () => {});
export const useProductVeticCategoryListAPI = () => {
  const [productVeticCategory, setProductVeticCategory] = useState<IProductVaticCategoryData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const appendInResult = (data: IProductVaticCategoryData) => {
    setProductVeticCategory((prev) => [...prev, data]);
  };
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(`${INVENTORY_MODULE?.PRODUCT_VETIC_CATEGORY?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IProductVaticCategoryResponse>) => {
          if (res.data.status === true) {
            setProductVeticCategory(res.data.data);
          } else {
            setProductVeticCategory([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      setProductVeticCategory([]);
      if (axios.isAxiosError(error)) {
        setProductVeticCategory([]);
        const axiosError = error as AxiosError;
        if (axiosError.code === "ERR_BAD_REQUEST") {
          toast.error("Error at server while fetching status list.");
        }
        if (axiosError.response?.status === 400) {
          toast.error(axiosError.message);
        }
        if (axiosError.response?.status === 500) {
          toast.error("Internal Server Error, Contact Tech Team.");
        }
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch, configuration]);

  return { execute, productVeticCategory, appendInResult };
};
